import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../app/axios";
import { API_URL } from "../../../app/config";
import axios from "axios";

export const getFlightPlaces = createAsyncThunk(
  "FlightPlaces/FindAllActiveFlightPlaces",
  async (formData: any) => {
    const response = await axiosApiInstance.post(
      `${API_URL}/FlightPlaces/FindAllActiveFlightPlaces`,
      formData
    );
    return response.data?.Data?.map((item: any) => {
      return {
        ID: item?.ID,
        Type: item?.Type,
        flightplace_name: item?.Airport,
        flightplace_code: item?.Value,
        city_name: item?.Name
          ? item.Name.split(" (")[0]
              .toLowerCase()
              .replace(/\b\w/g, (char: string) => char.toUpperCase())
          : "",
        country_name: item?.CountryCode,
        IsFavorite: item?.IsFavorite,
      };
    });
  }
);

export const getAllFlightPlaces = createAsyncThunk(
  "FlightPlaces/FromFindAllFlightPlaces",
  async (placeName: string) => {
    try {
      const response = await axios.get(
        `${API_URL}/fms/v1/airport/${placeName}`
      );

      return (
        response.data?.suggestions?.map((item: any) => {
          return {
            ID: item?.id,
            flightplace_name: item?.name,
            flightplace_code: item?.code,
            city_name: item?.city,
            country_name: item?.country,
          };
        }) || []
      );
    } catch (error: any) {
      return [];
    }
  }
);

export const getAllServicesForHome = createAsyncThunk(
  "TourServices/HomePage",
  async () => {
    try {
      const response = await axios.get(`${API_URL}/TourServices/HomePage`);

      return response.data?.Data;
    } catch (error: any) {
      return null;
    }
  }
);

// export const getAllFlightPlaces = createAsyncThunk(
//   "FlightPlaces/FromFindAllFlightPlaces",
//   async (placeName: string) => {
//     try {
//       const response = await axiosApiInstance.post(
//         `${API_URL}/FlightPlaces/FindAllFlightPlaces`,
//         { flightplace_name: placeName }
//       );

//       return (
//         response.data?.Data?.map((item: any) => {
//           return {
//             ID: item?.ID,
//             flightplace_name: item?.flightplace_name,
//             flightplace_code: item?.flightplace_code,
//             city_name: item?.city_name,
//             country_name: item?.country_name,
//             state_name: item?.state_name,
//             state_id: item?.state_id,
//             country_id: item?.country_id,
//             city_id: item?.city_id,
//             isactive: item?.isactive,
//           };
//         }) || []
//       );
//     } catch (error: any) {
//       return [];
//     }
//   }
// );

export const getTourServiceDetailByURL = createAsyncThunk(
  "TourServices/TourServiceDetailByURL",
  async (URL: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TourServices/TourServiceDetailByURL`,
        {
          URL: URL,
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      return {};
    }
  }
);
